import { useState } from "react";
import { useTranslate } from "ra-core";
import { useNavigate, useSearchParams } from "react-router";
import { Button } from "@/components/ui/button";
import { Layout } from "@/components/supabase/layout";
import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";

// Landing page of the access links shared by WhatsApp. The one-time token is
// only redeemed when the person clicks the button, so link previews (which
// open the URL on their own) can no longer use it up.
export const AccessPage = () => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const tokenHash = searchParams.get("token_hash");
  const [loading, setLoading] = useState(false);
  const [failed, setFailed] = useState(!tokenHash);

  const handleContinue = async () => {
    if (!tokenHash) return;
    setLoading(true);
    const { data, error } = await getSupabaseClient().auth.verifyOtp({
      token_hash: tokenHash,
      type: "recovery",
    });
    setLoading(false);
    if (error || !data.session) {
      setFailed(true);
      return;
    }
    const { access_token, refresh_token } = data.session;
    navigate(
      `/set-password?access_token=${access_token}&refresh_token=${refresh_token}&type=recovery`,
      { replace: true },
    );
  };

  return (
    <Layout>
      <div className="flex flex-col space-y-2 text-center">
        <h1 className="text-2xl font-semibold tracking-tight">
          {translate("crm.access.title")}
        </h1>
        <p className="text-sm text-muted-foreground">
          {translate(failed ? "crm.access.invalid" : "crm.access.description")}
        </p>
      </div>
      {failed ? null : (
        <Button
          className="w-full cursor-pointer"
          onClick={handleContinue}
          disabled={loading}
        >
          {translate("crm.access.continue")}
        </Button>
      )}
    </Layout>
  );
};

AccessPage.path = "/access";
